<script setup>
import { computed } from "vue";

const props = defineProps({
  pct: { type: Number, required: true }, // 0..1 (good share)
  good: { type: String, default: "#34d399" },
  bad: { type: String, default: "#fb7185" },
});

const cx = 100;
const cy = 100;
const r = 78;
const start = Math.PI;
const end = 2 * Math.PI;

const pt = (a) => [cx + r * Math.cos(a), cy + r * Math.sin(a)];

function arc(a0, a1) {
  const p0 = pt(a0);
  const p1 = pt(a1);
  const large = a1 - a0 > Math.PI ? 1 : 0;
  return `M${p0[0].toFixed(1)} ${p0[1].toFixed(1)} A${r} ${r} 0 ${large} 1 ${p1[0].toFixed(1)} ${p1[1].toFixed(1)}`;
}

const mid = computed(() => start + (end - start) * props.pct);
const trackPath = arc(start, end);
const goodPath = computed(() => arc(start, mid.value - 0.001));
const badPath = computed(() => arc(mid.value + 0.04, end));
</script>

<template>
  <svg viewBox="0 0 200 116" style="width: 100%; max-width: 230px">
    <path :d="trackPath" fill="none" stroke="var(--an-line)" stroke-width="16" stroke-linecap="round" />
    <path :d="goodPath" fill="none" :stroke="good" stroke-width="16" stroke-linecap="round" />
    <path :d="badPath" fill="none" :stroke="bad" stroke-width="16" stroke-linecap="round" />
  </svg>
</template>
